// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1FMpW","audioPlayer":"styles_audioPlayer__28vyT"};